import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { MdOutlineArrowForward } from "../assets/icons/vander";

export default function Terms() {
  const accordionData = [
    {
      title: "How does it work ?",
      content:
        "Users can subscribe to various plans for accessing available job data and book training sessions for practice.",
    },
    {
      title: "Do I definitely need a subscription ?",
      content:
        "Subscription is required for accessing premium features and getting better rates for sessions.",
    },
    {
      title: "What do I need to do to start applying ?",
      content:
        "You can go through the free data to apply. Otherwise signup and purchase a plan to see more opportunities and book sessions.",
    },
    {
      title: "What happens when I book a session ?",
      content:
        "You will get to practice mock for the position you applied for and get personalized feedback.",
    },
  ];
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <>
      <Navbar navClass="justify-end nav-light" />

      <section className="relative table w-full py-36 bg-[url('../../assets/images/hero/bg.jpg')] bg-top bg-no-repeat bg-cover">
        <div className="absolute inset-0 bg-emerald-900/90"></div>
        <div className="container">
          <div className="grid grid-cols-1 text-center mt-10">
            <h3 className="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">
              Terms & Services
            </h3>
          </div>
        </div>

        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="breadcrumb tracking-[0.5px] breadcrumb-light mb-0 inline-block">
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white/50 hover:text-white">
              <Link to="/index">HeroAcademi</Link>
            </li>
            <li
              className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white"
              aria-current="page"
            >
              Terms & Services
            </li>
          </ul>
        </div>
      </section>
      <div className="relative">
        <div className="shape overflow-hidden z-1 text-white dark:text-slate-900">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <section className="relative lg:py-24 py-16">
        <div className="container">
          <div className="md:flex justify-center">
            <div className="md:w-3/4">
              <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                <h5 className="text-xl font-medium mb-4">Introduction :</h5>
                <p className="text-slate-400">
                  Welcome to HeroAcademi, a service provided by Hanko Holdings
                  Limited, located at 49 Brinkburn Gardens, Edgware, England,
                  HA8 5PL. By accessing or using our platform, you agree to
                  comply with and be bound by the following Terms and
                  Conditions.
                </p>
                <h5 className="text-xl font-medium mb-4 mt-8">
                  User Agreements :
                </h5>
                <p className="text-slate-400">
                  HeroAcademi is an online recruitment platform that connects
                  employers and job seekers. We offer a range of services to
                  help you find job postings, applications, and other related
                  functionalities. To access certain premium features, you
                  <b className="text-danger-600"> must register</b>
                  as a user on HeroAcademi. You agree to provide accurate,
                  up-to-date information during the registration process and to
                  update this information as necessary to keep it accurate.
                </p>

                <p className="text-slate-400">
                  HeroAcademi offers various paid services, including premium
                  job listings and enhanced visibility options for seekers.
                  Payments are due upon invoice and are{" "}
                  <b className="text-danger-600">non-refundable,</b> except as
                  provided by applicable law. HeroAcademi reserves the right to{" "}
                  <b className="text-danger-600">remove job listings</b> that
                  violate our policies or terms, including but not limited to
                  discriminatory or illegal content.{" "}
                </p>
                <p className="text-slate-400">
                  HeroAcademi respects the privacy of its users. We collect and
                  process personal data as outlined in our{" "}
                  <b className="text-danger-600">Privacy Policy</b>. By using
                  our services, you consent to our data practices, which comply
                  with relevant data protection laws.{" "}
                </p>
                <p className="text-slate-400">
                  All content on HeroAcademi, including but not limited to
                  logos, design, text, and images, are the intellectual property
                  of Hanko Holdings Limited and are protected by copyright and
                  trademark laws. You may not reproduce, distribute, or display
                  any content from our platform without permission.
                </p>
                <p className="text-slate-400">
                  We may suspend or terminate your access to HeroAcademi if you
                  breach these Terms and Conditions. You may also terminate your
                  account at any time by contacting us.
                </p>

                <p className="text-slate-400"></p>
                <p className="text-slate-400 mt-3">
                  HeroAcademi is not liable for any direct, indirect,
                  incidental, or consequential damages that result from using
                  the platform, including the loss of data or income. We make no
                  guarantees regarding job placements or employment outcomes.
                </p>
                <p className="text-slate-400 mt-3">
                  These Terms and Conditions shall be governed by and construed
                  in accordance with the laws of England and Wales. Any disputes
                  arising from these terms shall be subject to the exclusive
                  jurisdiction of the courts in England and Wales.
                </p>
                <p className="text-slate-400 mt-3">
                  HeroAcademi reserves the right to modify these Terms and
                  Conditions at any time. Any changes will be posted on this
                  page, and the updated date will be reflected at the top of
                  this document. Your continued use of HeroAcademi after such
                  changes indicates your acceptance of the updated terms.
                </p>

                <h5 className="text-xl font-medium mb-4 mt-8">
                  Restrictions :
                </h5>
                <p className="text-slate-400">
                  You are specifically restricted from all of the following.You
                  agree not to:
                </p>
                <ul className="list-none text-slate-400 mt-3">
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Use the platform for unlawful purposes
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Post or upload any harmful content or malware
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Violate any applicable laws or regulations
                  </li>
                  {/* <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Digital Marketing Solutions for Tomorrow
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Our Talented & Experienced Marketing Agency
                  </li>
                  <li className="flex items-center mt-2">
                    <MdOutlineArrowForward className="text-indigo-600 align-middle me-2" />
                    Create your own skin to match your brand
                  </li> */}
                </ul>

                <h5 className="text-xl font-medium mt-8">
                  Users Question & Answer :
                </h5>

                <div
                  id="accordion-collapse"
                  data-accordion="collapse"
                  className="mt-6"
                >
                  {accordionData.map((item, index) => (
                    <div
                      key={index}
                      className={`relative shadow dark:shadow-gray-700 rounded-md overflow-hidden mt-4`}
                    >
                      <h2 className="text-base font-medium">
                        <button
                          onClick={() => toggleAccordion(index)}
                          type="button"
                          className={`flex justify-between items-center p-5 w-full font-medium text-left ${
                            activeIndex === index
                              ? "text-emerald-500 bg-gray-50 dark:bg-slate-800"
                              : ""
                          } `}
                          data-accordion-target="#accordion-collapse-body-1"
                          aria-expanded="true"
                          aria-controls="accordion-collapse-body-1"
                        >
                          <span>{item.title}</span>
                          <svg
                            data-accordion-icon
                            className={`size-4 shrink-0 ${
                              activeIndex === index ? "rotate-180" : ""
                            }`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </button>
                      </h2>
                      {activeIndex === index && (
                        <div aria-labelledby="accordion-collapse-heading-1">
                          <div className="p-5">
                            <p className="text-slate-400 dark:text-gray-400">
                              {item.content}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* <div className="mt-6">
                  <Link
                    to="#"
                    className="btn bg-indigo-600 hover:bg-indigo-700 text-white rounded-md"
                  >
                    Accept
                  </Link>
                  <Link
                    to="#"
                    className="btn bg-transparent hover:bg-indigo-600 border border-emerald-600 text-indigo-600 hover:text-white rounded-md ms-2"
                  >
                    Decline
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
